import { useState, useEffect } from "react";
import SwatchImagesPDP from "./SwatchImagesPdp";
import ProductAttributes from "./ProductAttributes";
import ColorSliderPdp from "./ColorSliderPdp";
import SpecialColorSliderPdp from "./SpecialColorSliderPdp";
import "../Products.css";
import ProductBrandLogos from "./ProductBrandLogos";
import ProductGallerySlider from "./ProductGallerySlider";
import PdpGalleryPopup from "./PdpGalleryPopup";
import PdpVisualizerPopup from "./PdpVisualizerPopup";
import SizeAvailables from "./SizeAvailables";
import $ from "jquery";

export default function ProductDetailPage({ product, type, sku }) {
  const [products, setProducts] = useState([]);
  const [sizeProducts, setSizeProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [displayPopup, setDisplayPopup] = useState("hide");
  const [displayVisualizer, setDisplayVisualizer] = useState("hide");
  const [visualizerType, setVisualizerType] = useState("collection");
  const wpProductFilter = window.wpProductFilter;
  const wpProductCategory = window.wpProductCategory;
  const show_size_on_pdp = wpProductCategory.show_size_on_pdp
    ? wpProductCategory.show_size_on_pdp
    : "";
  const brand_collection = product.brand_collection;
  const allInStock = window.wpProductCategory.in_stock == "all" ? true : false;
  const inStock1 =
    product.in_stock !== "" || product.in_stock !== undefined
      ? product.in_stock
      : "";
  const inStock = allInStock === false ? inStock1 : "";

  const siteInfo = window.wpProductFilter.siteInfo;
  const pdpPageLayout = siteInfo.pdpPageLayout;
  const contactFormWithProduct = siteInfo.contactFormWithProduct;
  const contactFormWithProductUrl = siteInfo.contactFormWithProductUrl;
  const getcouponbtn = siteInfo.getcouponbtn;
  const getcouponreplace = siteInfo.getcouponreplace;
  const getcouponreplacetext = siteInfo.getcouponreplacetext;
  const getcouponreplaceurl = siteInfo.getcouponreplaceurl;
  const show_financing = siteInfo.show_financing;
  const pdp_get_finance = siteInfo.pdp_get_finance;
  const getfinancereplace = siteInfo.getfinancereplace;
  const getcoupon_link = siteInfo.getcoupon_link;
  const showprice = siteInfo.plpshowprice;
  const hidepriceinstockplpforbrands = siteInfo.hidepriceinstockplpforbrands;
  const hidepriceinstockplp = siteInfo.hidepriceinstockplp;
  const rugscallforprice = siteInfo.rugscallforprice;
  const rugscallforpriceurl = siteInfo.rugscallforpriceurl;
  const showcallforprice = siteInfo.showcallforprice;
  const showpricestrik = siteInfo.showpricestrik;
  const showretailandspecialprice = siteInfo.showretailandspecialprice;
  const showpricenormalplp = siteInfo.showpricenormalplp;
  const normalpricecat = siteInfo.normalpricecat;
  const hidepricenormalplpforbrands = siteInfo.hidepricenormalplpforbrands;
  const hidepricenormalplp = siteInfo.hidepricenormalplp;
  const showrugsbutton = siteInfo.showrugsbutton;
  const rugsbrands = siteInfo.rugsbrands;
  const currentPageID = siteInfo.currentPageID;
  const arearugshowsku = siteInfo.arearugshowsku;
  const rugpageurl = siteInfo.rugpageurl + "?id=" + currentPageID;
  const showpdpsamplebtn = siteInfo.showpdpsamplebtn;
  const showsamplelabel = siteInfo.showsamplelabel;
  const site_code = siteInfo.site_code;
  const hideinstockcoupon = siteInfo.hideinstockcoupon;
  const current_user_id = siteInfo.current_user_id;
  const isworkbook = siteInfo.isworkbook;
  const showsharebtn = siteInfo.showsharebtn;
  const pdpbcslayout = siteInfo.pdpbcslayout;
  const sale_for_only_brand = siteInfo.sale_for_only_brand;
  const sale_brand_list = siteInfo.sale_brand_list;
  const sale_brand_list_arr = Array.isArray(sale_brand_list)
    ? sale_brand_list.map((str) => str.toLowerCase())
    : [];

  const getfinancereplaceurl =
    getfinancereplace === "1"
      ? siteInfo.getfinancereplaceurl
      : "/flooring-financing/";
  const getfinancetext =
    getfinancereplace === "1" ? siteInfo.getfinancetext : "Financing";
  const manufacturerBrands = ["Bruce", "AHF", "Shaw"];
  var productManufacturer = manufacturerBrands.includes(product.manufacturer)
    ? product.brand.toLowerCase()
    : product.manufacturer.toLowerCase();
  var productManufacturer = productManufacturer.replace(/\s/g, "");
  const cat =
    product.z_prod_type === "rugs" ? "area_rugs" : product.z_prod_type;
  let link_action = "add_Fav ";
  let icon_class = "fa fa-heart-o";
  let fav_text = "Add as Favorite";

  if (
    isworkbook == 1 &&
    current_user_id !== undefined &&
    current_user_id !== ""
  ) {
    let fav_details = wpProductCategory.fav_details;
    link_action = fav_details["link_action"]
      ? fav_details["link_action"]
      : "add_Fav ";
    icon_class = fav_details["icon_class"]
      ? fav_details["icon_class"]
      : "fa fa-heart-o";
    fav_text = fav_details["fav_text"]
      ? fav_details["fav_text"]
      : "Add as Favorite";
  }

  useEffect(() => {
    fetchProducts();
    if (show_size_on_pdp === "yes") {
      fetchSizeWiseProducts();
    }
    if (
      showpdpsamplebtn == 1 &&
      product.hasOwnProperty("sample_sku") &&
      product.sample_sku.trim() != ""
    ) {
      $("a.sample-btn").on("click", function () {
        $("#sample_minicart").remove();
        var sample_src = $(".sample-btn").data("frame");
        $(document)
          .find(".sampleProduct_popUp .popUp-content")
          .html(
            '<iframe id="sample_minicart" src="' +
              sample_src +
              '" onload="sendOrigin(this)" style="width: 1200px; height: 600px;"></iframe>'
          );

        function sendOrigin(iframe) {
          iframe.contentWindow.postMessage(
            { type: "parent-origin", origin: window.location.origin },
            "https://sample-products.com/"
          );
        }
        $(
          ".minicart .uabb-offcanvas.uabb-custom-offcanvas.uabb-offcanvas-type-noraml"
        ).addClass("uabb-off-canvas-show");
        $(
          ".minicart .uabb-offcanvas.uabb-custom-offcanvas.uabb-offcanvas-type-noraml"
        ).css("right", 0);
      });
      $(".minicart .uabb-offcanvas-close").on("click", function () {
        $(
          ".minicart .uabb-offcanvas.uabb-custom-offcanvas.uabb-offcanvas-type-noraml"
        ).css("right", "-400px");
      });
    }
  }, [product]);

  const jsonld = {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: product.name + " " + product.sku,
    image: `https://mm-media-res.cloudinary.com/image/fetch/h_600,w_600,c_limit/https://${product.swatch}`,
    description: product.name + " " + product.sku,
    sku: product.sku,
    mpn: product.sku,
    brand: {
      "@type": "thing",
      name: product.brand,
    },
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "Collection",
        value: product.collection_facet ?? "",
      },
      {
        "@type": "PropertyValue",
        name: "Color",
        value: product.color_facet ?? "",
      },
      {
        "@type": "PropertyValue",
        name: "Construction",
        value: product.construction ?? "",
      },
      {
        "@type": "PropertyValue",
        name: "Species",
        value: product.species ?? "",
      },
      {
        "@type": "PropertyValue",
        name: "Surface Type",
        value: product.surface_type ?? "",
      },
      {
        "@type": "PropertyValue",
        name: "Shade",
        value: product.shade ?? "",
      },
      {
        "@type": "PropertyValue",
        name: "Shape",
        value: product.shape ?? "",
      },
      {
        "@type": "PropertyValue",
        name: "Look",
        value: product.look ?? "",
      },
      {
        "@type": "PropertyValue",
        name: "Material",
        value: product.material ?? "",
      },
      {
        "@type": "PropertyValue",
        name: "Wearlayer",
        value: product.wearlayer ?? "",
      },
      {
        "@type": "PropertyValue",
        name: "Application",
        value: product.application ?? "",
      },
      {
        "@type": "PropertyValue",
        name: "Style",
        value: product.style ?? "",
      },
      { "@type": "PropertyValue", name: "Width", value: product.width ?? "" },
      {
        "@type": "PropertyValue",
        name: "Length",
        value: product.length ?? "",
      },
      {
        "@type": "PropertyValue",
        name: "Thickness",
        value: product.thickness ?? "",
      },
      {
        "@type": "PropertyValue",
        name: "Fiber",
        value: product.fiber ?? "",
      },
      {
        "@type": "PropertyValue",
        name: "Location",
        value: product.location ?? "",
      },
      {
        "@type": "PropertyValue",
        name: "Installation Method",
        value: product.installation_facet ?? "",
      },
      {
        "@type": "PropertyValue",
        name: "Warranty",
        value: product.warranty_text ?? "",
      },
      {
        "@type": "PropertyValue",
        name: "Description",
        value: product.description ?? "",
      },
    ],
    offers: {
      "@type": "offer",
      priceCurrency: "USD",
      price: product.price ?? "",
      priceValidUntil: "",
    },
  };

  const fetchProducts = async () => {
    const query = new URLSearchParams({
      brand_collection: brand_collection,
      category: type,
      in_stock: inStock,
      current_sku: product.sku,
    });

    try {
      const response = await fetch(`${wpProductFilter.apiEndpoint}?${query}`);
      const data = await response.json();
      setProducts(data.products_group_by);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchSizeWiseProducts = async () => {
    const query1 = new URLSearchParams({
      brand_collection: brand_collection,
      category: type,
      in_stock: inStock,
      show_size_on_pdp: show_size_on_pdp,
      color: product.color,
    });

    try {
      const response1 = await fetch(`${wpProductFilter.apiEndpoint}?${query1}`);
      const data1 = await response1.json();
      setSizeProducts(data1.products_group_by);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false);
    }
  };
  const populatePopup = (status) => {
    setDisplayPopup(status);
  };
  const populateVisualizer = (status, type) => {
    setVisualizerType(type);
    setDisplayVisualizer(status);
  };
  return (
    <div
      className={`product_detail_wrap ${
        pdpPageLayout === "normal"
          ? "normal_pdp_layout"
          : "color_switch_pdp_layout"
      }`}>
      <div className="row">
        <div className="col-md-6 col-sm-12 product-swatch">
          <div className="imagesHolder">
            {showsamplelabel == 1 &&
              product.hasOwnProperty("sample_sku") &&
              product.sample_sku.trim() != "" && (
                <span class="orderSampleStrip">Sample Available</span>
              )}
            <SwatchImagesPDP
              swatch={product.swatch}
              populatePopup={populatePopup}
              height={600}
              width={600}
            />

            <div id="roomvo">
              <div className="roomvo-container">
                <a
                  className="roomvo-stimr button"
                  data-sku={product.sku}
                  style={{ visibility: "hidden" }}>
                  <i className="fa fa-camera" aria-hidden="true"></i> &nbsp;See
                  In My Room
                </a>
              </div>
            </div>

            <script type="text/javascript">
              {`       
                function getProductSKU() {                       
                  return "${productManufacturer}-${sku.toLowerCase()}";
                } 
              `}
            </script>
            <div class="image-expander">
              <img
                alt="zoom-img"
                class="img"
                src="/wp-content/plugins/mm-product-listing/build/media/popup_opener.webp"
                onClick={(e) => populatePopup("show")}
              />
            </div>
          </div>
          <div className="product_gallery_slider">
            <ProductGallerySlider product={product} />
          </div>
          {products[Object.keys(products)[0]] &&
            product?.custom &&
            product.custom != "" && (
              <div className="visualizer_button_group">
                <div className="button-wrapper">
                  <div className="dual-button">
                    <button
                      onClick={(e) => populateVisualizer("show", "product")}
                      className="button contact-btn">
                      Visualize Product
                    </button>

                    <button
                      onClick={(e) => populateVisualizer("show", "collection")}
                      className="button contact-btn">
                      Visualize Collection
                    </button>
                  </div>
                </div>
              </div>
            )}
        </div>

        <div className="col-md-6 col-sm-12 product-box">
          {pdpbcslayout === "1" ? (
            <div className="row bcs_layout">
              <div class="col-md-12">
                <h1 class="fl-post-title collection_title">
                  {product.collection_name}
                </h1>
                {product.brand_facet.toLowerCase() !== "in-stock" && (
                  <h2 class="fl-post-title brand_title">
                    {"BY " + product.brand_facet}
                  </h2>
                )}
                <h3 class="fl-post-title color_sku_title">
                  <span className="color_title">{product.color}</span>
                  <span className="sku_title">{" | SKU #" + product.sku}</span>
                </h3>
              </div>
            </div>
          ) : (
            <div class="row">
              <div class="col-md-6">
                <h1 class="fl-post-title">{product.collection_name}</h1>
                <h2 class="fl-post-title">
                  {arearugshowsku == "1" && product.z_prod_type === "rugs"
                    ? product.sku
                    : product.color}
                </h2>
                {product.in_stock == 1 &&
                  product.z_prod_type != "carpet" &&
                  showprice == 1 &&
                  product.price != 0 &&
                  showretailandspecialprice == 1 && (
                    <div class="price loop-price">
                      {product.msrp_unit_price ? (
                        <p>
                          Retail Price: $
                          {Number(product.msrp_unit_price).toFixed(2)}/
                          {product.price_unit} installed
                        </p>
                      ) : (
                        ""
                      )}
                      <span>
                        <strong>
                          Special Price: ${Number(product.price).toFixed(2)}/
                          {product.price_unit} installed
                        </strong>
                      </span>
                    </div>
                  )}
                {product.in_stock == 1 &&
                  showprice == 1 &&
                  product.price != 0 &&
                  (showretailandspecialprice != 1 ||
                    product.z_prod_type == "carpet") &&
                  (hidepriceinstockplp == 0 ||
                    (hidepriceinstockplp == 1 &&
                      !hidepriceinstockplpforbrands.includes(
                        product.brand.toLowerCase()
                      ))) && (
                    <div className="price">
                      <strong>
                        {showpricestrik == 1 && product.msrp_unit_price ? (
                          <span class="msrp-price">
                            ${Number(product.msrp_unit_price).toFixed(2)}
                          </span>
                        ) : (
                          ""
                        )}
                        <span class="sale-price">
                          ${Number(product.price).toFixed(2)}
                        </span>
                      </strong>
                      {product.z_prod_type != "rugs" &&
                        `/${product.price_unit}`}
                    </div>
                  )}
                {product.in_stock == 1 && showcallforprice == 1 && (
                  <div className="price">
                    <strong>Call for Price</strong>
                  </div>
                )}

                {product.in_stock == 0 &&
                  showpricenormalplp == 1 &&
                  normalpricecat.includes(cat.toLowerCase()) &&
                  product.price != 0 &&
                  (hidepricenormalplp == 0 ||
                    (hidepricenormalplp == 1 &&
                      !hidepricenormalplpforbrands.includes(
                        product.brand.toLowerCase()
                      ))) && (
                    <div className="price">
                      <strong>
                        {showpricestrik == 1 && product.msrp_unit_price ? (
                          <span class="msrp-price">
                            ${Number(product.msrp_unit_price).toFixed(2)}
                          </span>
                        ) : (
                          ""
                        )}
                        <span class="sale-price">
                          ${Number(product.price).toFixed(2)}
                        </span>
                      </strong>
                      {product.z_prod_type != "rugs" &&
                        `/${product.price_unit}`}
                    </div>
                  )}
              </div>
              <div class=" col-md-6 text-right">
                <ProductBrandLogos product={product} />
                {product.in_stock == 1 && (
                  <div class="col-lg-12 MarkInstock">
                    <img
                      src="/wp-content/plugins/mm-product-listing/build/media/instock_mark.webp"
                      className="Instock-mark"
                      alt="Instock-Mark"
                    />
                    <span>IN-STOCK</span>
                  </div>
                )}
                {product.in_stock == 1 && showsharebtn == 1 && (
                  <div className="col-lg-12 share">
                    <div className="share_title">SHARE</div>
                    <ul className="share_list">
                      <li className="share_list_item">
                        <a
                          href={`http://www.facebook.com/sharer.php?u=${window.location.href}`}
                          target="_blank">
                          <img
                            src="/wp-content/plugins/mm-product-listing/build/media/facebook.webp"
                            className="share-mark"
                            alt="Facebook Share"
                          />
                        </a>
                      </li>
                      <li className="share_list_item">
                        <a
                          href={`https://twitter.com/share?url=${window.location.href}`}
                          target="_blank">
                          <img
                            src="/wp-content/plugins/mm-product-listing/build/media/twitter.webp"
                            class="share-mark"
                            alt="Twitter Share"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          )}
          {pdpPageLayout === "normal" && (
            <div className="row pdp-colors-available-box">
              <div className="col-md-12">
                <div className="product-colors">
                  <ul>
                    <li className="found">
                      {products[Object.keys(products)[0]]?.length}
                    </li>
                    <li className="colors"> COLORS AVAILABLE </li>
                  </ul>
                </div>
                <div id="product-colors">
                  {products[Object.keys(products)[0]] ? (
                    <ColorSliderPdp
                      products={products[Object.keys(products)[0]]}
                      currentProductSku={product.sku}
                      currentProductColor={
                        Object.keys(sizeProducts).length > 0
                          ? product.color
                          : ""
                      }
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          )}
          {pdpPageLayout !== "normal" && (
            <div className="row pdp-colors-available-box">
              <div className="col-md-12">
                <div className="product-colors">
                  <ul>
                    <li className="found">
                      {products[Object.keys(products)[0]]?.length}
                    </li>
                    <li className="colors"> COLORS AVAILABLE </li>
                  </ul>
                </div>
                <div id="product-colors">
                  {products[Object.keys(products)[0]] ? (
                    <SpecialColorSliderPdp
                      products={products[Object.keys(products)[0]]}
                      currentProductSku={product.sku}
                      currentProductColor={
                        Object.keys(sizeProducts).length > 0
                          ? product.color
                          : ""
                      }
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          )}
          {Object.keys(sizeProducts).length > 0 && (
            <SizeAvailables
              products={sizeProducts[Object.keys(sizeProducts)[0]]}
              sku={product.sku}
            />
          )}
          <div className="button-wrapper">
            <div className="dual-button">
              {contactFormWithProduct === "1" &&
              (contactFormWithProductUrl !== "" ||
                contactFormWithProductUrl !== undefined) ? (
                <a
                  href={`${contactFormWithProductUrl}?product_sku=${product.sku}`}
                  className="button contact-btn">
                  Contact Us
                </a>
              ) : (
                <a href="/contact-us/" className="button contact-btn">
                  Contact Us
                </a>
              )}

              {(pdp_get_finance != 1 || pdp_get_finance == "") && (
                <a href={getfinancereplaceurl} className="finance-btn button">
                  {getfinancetext}
                </a>
              )}
            </div>

            {getcouponbtn == 1 &&
            getcoupon_link != "" &&
            (product.in_stock == 0 ||
              (product.in_stock == 1 && hideinstockcoupon != 1)) &&
            (sale_for_only_brand == 0 ||
              sale_brand_list_arr.includes(
                product.brand_facet.toLowerCase()
              )) ? (
              <a href={getcoupon_link} className="button alt getcoupon-btn">
                <span className="fl-button-text">GET COUPON</span>
              </a>
            ) : (
              ""
            )}
            {rugscallforprice == 1 &&
              rugscallforpriceurl != "" &&
              product.z_prod_type == "rugs" && (
                <a
                  href={rugscallforpriceurl}
                  className="button callforprice-btn">
                  CALL FOR PRICE
                </a>
              )}
            {getcouponreplace === "1" &&
            (getcouponreplaceurl !== undefined && getcouponreplaceurl) !== "" &&
            getcouponreplacetext !== "" &&
            getcouponreplacetext !== undefined ? (
              <a
                href={getcouponreplaceurl}
                className="button alt custompdpbtn getcoupon-btn">
                {getcouponreplacetext}
              </a>
            ) : (
              ""
            )}
            {showpdpsamplebtn == 1 &&
            product.hasOwnProperty("sample_sku") &&
            product.sample_sku.trim() != "" ? (
              <a
                href="javascript:void(0)"
                data-frame={`https://sample-products.com/sampleorder/cart/add/product/${product.sample_sku}?store=${site_code}`}
                className="button alt custompdpbtn sample-btn"
                role="button">
                ORDER SAMPLE
              </a>
            ) : (
              ""
            )}
            {showrugsbutton === "1" &&
            rugsbrands.indexOf(product.brand) !== -1 ? (
              <a href={rugpageurl} class="floorvana-btn button">
                CREATE A RUG
              </a>
            ) : (
              ""
            )}

            {isworkbook == 1 &&
            current_user_id !== undefined &&
            current_user_id !== "" ? (
              <a
                className={`button alt fl-button pdpFavbutton ${link_action}`}
                data-user={current_user_id}
                data-id={product.sku}>
                <i className={icon_class} aria-hidden="true">
                  {" "}
                </i>
                {/* <span className="">{fav_text}</span> */}
                <span class="rf">Remove From Favorite</span>
                <span class="af">Add as Favorite</span>
              </a>
            ) : (
              ""
            )}
          </div>
          {pdpbcslayout === "1" && (
            <div class="row bcs_layout_logo">
              <div class=" col-md-12">
                {product.brand_facet.toLowerCase() !== "in-stock" && (
                  <ProductBrandLogos product={product} />
                )}
                {product.in_stock == 1 && (
                  <div class="col-lg-12 MarkInstock">
                    <img
                      src="/wp-content/plugins/mm-product-listing/build/media/instock_mark.webp"
                      className="Instock-mark"
                      alt="Instock-Mark"
                    />
                    <span>IN-STOCK</span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div id="product-attributes-wrap">
            <ProductAttributes product={product} />
          </div>
        </div>
      </div>
      {/* <div className={`pdpGalleryImagePopup ${displayPopup}`}> */}
      <div className={`pdpGalleryImagePopup ${displayPopup}`}>
        <div className="closePopup">
          <span onClick={(e) => populatePopup("hide")}>X</span>
        </div>
        <PdpGalleryPopup
          swatch={product.swatch}
          galleryImages={product.gallery_images}
          height={800}
          width={800}
          productName={`${product.name} ${product.sku}`}
        />
      </div>

      {products[Object.keys(products)[0]] &&
        product?.custom &&
        product.custom != "" && (
          <div className={`pdpVisualizerPopup ${displayVisualizer}`}>
            <div className="pdpVisualizerPopupInner">
              <div className="pdpVisualizerPopupInnerSection">
                <div className="closePopup">
                  <span onClick={(e) => populateVisualizer("hide", "product")}>
                    X
                  </span>
                </div>
                <PdpVisualizerPopup
                  products={products[Object.keys(products)[0]]}
                  product={product}
                  visualizerType={visualizerType}
                />
              </div>
            </div>
          </div>
        )}
      <script type="application/ld+json">{JSON.stringify(jsonld)}</script>
    </div>
  );
}
